// extracted by mini-css-extract-plugin
export var container = "_p2-0";
export var dotAnimation = "_p2-2";
export var dotsLoading = "_p2-1";